<template>
  <div id="container" style="width: 100%; height: 100%"></div>

  <div class="absolute right-3 w-52 top-3 z-10">
    <el-autocomplete
      v-model="state.key"
      :fetch-suggestions="onSeach"
      clearable
      placeholder="请输入关键字"
      @select="onSelect"
    >
      <template #default="{ item }">
        <div class="py-2">
          <ul>
            {{
              item.value
            }}
          </ul>
          <ul class="text-gray-400 flex items-baseline mt-1">
            <el-icon color="#a2a2a2"><location /></el-icon>
            <text class="text-sm pl-1">
              {{ item.address }}
            </text>
          </ul>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import store from "@/store";

export default {
  props: {
    point: Array,
  },
  setup(props, { emit }) {
    const searchDom = ref(null);
    const state = reactive({});
    let map, geoc;

    const myIcon = new BMapGL.Icon(
      require("@/assets/images/marker.png"),
      new BMapGL.Size(30, 30),
      {
        // 指定定位位置。
        // 当标注显示在地图上时，其所指向的地理位置距离图标左上
        // 角各偏移10像素和25像素。您可以看到在本例中该位置即是
        // 图标中央下端的尖角位置。
        anchor: new BMapGL.Size(15, 28),
      }
    );

    onMounted(() => {
      //创建对象
      map = new BMapGL.Map("container", {
        enableIconClick: true,
      }); // 创建Map实例
      var point = store.state.mapCenter || new BMapGL.Point(117.23, 31.83); // 创建点坐标
      map.centerAndZoom(point, 15); // 初始化地图,设置中心点坐标和地图级别
      map.enableScrollWheelZoom();

      geoc = new BMapGL.Geocoder();
      if (props.point?.length == 2) {
        map.clearOverlays();
        var point1 = new BMapGL.Point(props.point[0], props.point[1]);

        var marker = new BMapGL.Marker(point1, { icon: myIcon });
        map.addOverlay(marker);
      }

      map.addEventListener("click", function (e) {
        map.clearOverlays();
        var point = new BMapGL.Point(e.latlng.lng, e.latlng.lat);

        var marker = new BMapGL.Marker(point, { icon: myIcon });
        map.addOverlay(marker);

        store.commit("setMapCenter", point);

        geoc.getLocation(point, function (res) {
          const { address, address_detail, poi_desc } = res.content;
          emit("setAddress", {
            longitude: e.latlng.lng,
            latitude: e.latlng.lat,
            province: address_detail.province,
            city: address_detail.city,
            district: address_detail.district,
            township: address_detail.town, //街道
            address: address + poi_desc,
          });
        });
      });
    });

    const onSeach = (value, callback) => {
      var local = new BMapGL.LocalSearch(map, {
        onSearchComplete: (results) => {
          if (local.getStatus() === BMAP_STATUS_SUCCESS) {
            const suggestions = results._pois.map((poi) => ({
              value: poi.title,
              address: poi.address,
              location: poi.point,
            }));
            callback(suggestions);
          }
        },
      });
      local.search(value);
    };

    const onSelect = (item) => {
      var point = new BMapGL.Point(item.location.lng, item.location.lat);
      var marker = new BMapGL.Marker(point, { icon: myIcon });
      map.addOverlay(marker);
      map.centerAndZoom(point, 18); // 初始化地图,设置中心点坐标和地图级别

      geoc.getLocation(point, function (res) {
        const { address, address_detail, poi_desc } = res.content;
        emit("setAddress", {
          longitude: item.location.lng,
          latitude: item.location.lat,
          province: address_detail.province,
          city: address_detail.city,
          district: address_detail.district,
          township: address_detail.town, //街道
          address: address + poi_desc,
        });
      });
    };
    return { state, searchDom, onSeach, onSelect };
  },
};
</script>
<style lang="less" scoped></style>
